import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource, MatDialog } from '@angular/material';
import { RegistrationService } from 'src/app/services/http/business/registration/registration.service';
import { TranslateService } from '@ngstack/translate';
import { SendSmsComponent } from 'src/app/pages/management/send-sms/send-sms.component';
import { CourseListForMoveStudentComponent } from '../course-list-for-move-student/course-list-for-move-student.component';
import { CourseService } from 'src/app/services/http/business/course/course.service';
import { IConfirm } from 'src/app/interfaces/confirm';
import { ConfirmComponent } from 'src/app/components/confirm/confirm.component';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { StudentTransferDetailsComponent } from '../student-transfer-details/student-transfer-details.component';

@Component({
  selector: 'app-register-student-course',
  templateUrl: './register-student-course.component.html',
  styleUrls: ['./register-student-course.component.css']
})
export class RegisterStudentCourseComponent implements OnInit {

  errors = new Array();
  errObject: any;
  param: any;

  dataSource = new MatTableDataSource();
  displayedColumns: string[] = [
    'row',
    this.translate.get("label.name"),
    this.translate.get("label.nationalCode"),
    this.translate.get("label.mobile"),
    'registrationType',
    this.translate.get("label.registrationStatus"),
    this.translate.get("label.finalPayment"),
    'function'
  ];

  constructor(
    private dialog: MatDialog,
    private registrationService: RegistrationService,
    private courseService: CourseService,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    public translate: TranslateService,
    private dialogRef: MatDialogRef<RegisterStudentCourseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    console.log(this.data);

    this.showStudents();
  }

  showStudents() {
    this.registrationService.registerStudentList({ Id: this.data.CourseId }).subscribe(res => {
      this.dataSource = res.DataList;
    }, () => { })
  }

  sendSmsGroup() {
    this.dialog
      .open(SendSmsComponent, {
        width: '700px',
        data: {
          CourseId: this.data.CourseId,
          LevelName: this.data.LevelName
        }
      });
  }

  sendSms(data) {
    this.dialog
      .open(SendSmsComponent, {
        width: '700px',
        data: {
          StudentNationalCode: data.NationalCode,
          StudentName: data.FirstName + ' ' + data.LastName,
          Mobile: data.CellPhoneNumber
        }
      });
  }

  moveStudent(data) {
    data.CourseId = this.data.CourseId;
    this.dialog
      .open(CourseListForMoveStudentComponent, {
        width: '90%',
        data: data
      }).afterClosed().subscribe(() => {
        this.showStudents();
      });
  }

  removeStudent(data) {

    let confirm: IConfirm = {
      accept: true,
      message: "آیا از حذف دانشجو از کلاس اطمینان دارید؟",
      alert: null,
      yesLabel: "بله",
      noLabel: "خیر"
    };

    this.dialog
      .open(ConfirmComponent, {
        width: "300px",
        data: confirm
      })
      .afterClosed()
      .subscribe(res => {
        if (res) {
          this.registrationService.removePrivateRegistration({Id: data.RegistrationId}).subscribe(res => {
            if (res) {
              this.snackBar.OpenSnackBar(
                'دانشجو با موفقیت از لیست کلاس حذف شد',
                "OK",
                5000,
                SoundEnum.beep
              );
              this.showStudents();
            }
            else {
              this.snackBar.OpenSnackBar(
                'خطا در حذف دانشجو',
                "OK",
                5000,
                SoundEnum.beep
              );
            }
          }, err => {
            this.errObject = this.errorService.getError(err);
            this.param = this.errorService.objectError(this.errObject);
            this.errors = this.errorService.returnError(err);
          })
        }
      })
  }

  addToVirtualClass(data) {

    let confirm: IConfirm = {
      accept: true,
      message: "آیا از اضافه کردن دانشجو به جلسه آنلاین اطمینان دارید؟",
      alert: null,
      yesLabel: "بله",
      noLabel: "خیر"
    };

    this.dialog
      .open(ConfirmComponent, {
        width: "500px",
        data: confirm
      })
      .afterClosed()
      .subscribe(res => {
        if (res) {
          if (this.data.AddStudentToVirtualCourse) {
            var courseCommand = {
              NationalCode: data.NationalCode,
              RegistrationId: data.RegistrationId
            }
            this.courseService.addStudentToVirtualCourse(courseCommand).subscribe(() => {
              this.snackBar.OpenSnackBar(
                'دانش آموز با موفقیت به جلسه آنلاین اضافه گردید',
                "ok",
                5000,
                SoundEnum.beep
              );
            },
              err => {
                this.errObject = this.errorService.getError(err);
                this.param = this.errorService.objectError(this.errObject);
                this.errors = this.errorService.returnError(err);
              })
          }
          if (this.data.AddStudentToVirtualSession) {
            var sessionCommand = {
              NationalCode: data.NationalCode,
              RegistrationId: data.RegistrationId,
              ScoId: this.data.Session.AdobeConnectScoId
            };
            this.courseService.addStudentToVirtualSession(sessionCommand).subscribe(() => {
              this.snackBar.OpenSnackBar(
                'دانش آموز با موفقیت به جلسه آنلاین اضافه گردید',
                "ok",
                5000,
                SoundEnum.beep
              );
            },
              err => {
                this.errObject = this.errorService.getError(err);
                this.param = this.errorService.objectError(this.errObject);
                this.errors = this.errorService.returnError(err);
              })
          }
        }
      })
  }

  onTransferDetailsRequest(fromCourseId: number)
  {
    this.dialog.open(StudentTransferDetailsComponent,{
      data: {
        fromCourseId: fromCourseId,
        toCourseId: this.data.CourseId,
      },
      minWidth: '40%'
    });
  }

  onNoClick() {
    this.dialogRef.close();
  }
}
